//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BlockContent from 'sanity-blocks-vue-component';

import ContentLink from '~/components/ContentLink.vue';

export default {
  components: {
    BlockContent,
  },

  props: {
    positions: {
      type: Array,

      default: () => [],
    },
  },

  data() {
    return {
      serializers: {
        marks: {
          link: ContentLink,
        },
      },
    };
  },
};
